/**
 * Interface that contains information about a field value, error and if it's required.
 *
 * The required field holds a reference to a function that, when called, should populate
 * the error field.
 */
export interface FieldData {
    error: string;
    value: string;
    required?: () => string;
}

export function fieldsAreEqual(primary: FieldData, secondary: FieldData): boolean {
    return primary.value === secondary.value && primary.error === secondary.error;
}
